import { useChannelsLite } from './useChannelsLite';

/**
 * A hook that returns the first matching channel for a given workflow template id.
 * @param workflowTemplateId - The id of the workflow template.
 * @returns The channel for the given workflow template id, or undefined.
 */
export function useWorkflowChannel(workflowTemplateId?: string): MBAPI.ChannelListItem | undefined {
  const { channels } = useChannelsLite();
  return channels.find(channel => channel.workflowTemplateId === workflowTemplateId);
}
